if (!customElements.get('bio-survey')) {
  customElements.define(
    'bio-survey',
    class BioSurvey extends HTMLElement {
      connectedCallback() {
        const facts = this.querySelector('[data-bsv-facts]');
        const pill = document.querySelector('.bp-ingredients [data-bp-modal-open]');
        if (facts && pill) {
          facts.hidden = false;
          facts.addEventListener('click', () => pill.click());
        }

        const stats = [...this.querySelectorAll('[data-bsv-stat]')];
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!stats.length || still || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;

        this.classList.add('is-pending');
        stats.forEach((stat) => {
          const count = stat.querySelector('[data-bsv-count]');
          if (count) count.textContent = '0';
        });
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.observer.unobserve(entry.target);
              this.reveal(entry.target);
            });
          },
          { threshold: 0.5 }
        );
        stats.forEach((stat) => this.observer.observe(stat));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      reveal(stat) {
        requestAnimationFrame(() => stat.classList.add('is-shown'));
        const count = stat.querySelector('[data-bsv-count]');
        if (!count) return;
        const target = Number(count.dataset.to) || 0;
        const duration = 1600;
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          count.textContent = Math.round(target * eased);
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }
  );
}
